import React, { useState } from "react";
import {
  AppBar,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormHelperText,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  Rating,
  Select,
  Slide,
  TextField,
  Toolbar,
  Typography,
  useMediaQuery,
} from "@mui/material";
import "./createReviewModal.scss";

// icon
import EditIcon from "@mui/icons-material/Edit";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import StarRateRoundedIcon from "@mui/icons-material/StarRateRounded";
import StarOutlineRoundedIcon from "@mui/icons-material/StarOutlineRounded";
import { LoadingButton } from "@mui/lab";
import productRating from "../../../stores/productRatingStore";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import dayjs from "dayjs";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const CreateReviewModal = ({ productID }) => {
  const max_width600 = useMediaQuery("(max-width:600px)");
  const [open, setOpen] = useState(false);
  const ProductRatingStore = productRating();
  const todayDate = new Date();

  const [newReview, setNewReview] = useState({
    rating: null,
    review: "",
    username: "",
    created_at: "",
  });

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setNewReview({
      rating: null,
      review: "",
      username: "",
      created_at: "",
    });
    setOpen(false);
  };

  const handleCreateReview = async () => {
    const success = await ProductRatingStore.createRating({
      ...newReview,
      productID,
    });
    if (success) {
      handleClose();
      await ProductRatingStore.fetchAllRating();
    }
  };
  return (
    <div className="create-review-modal">
      <Button
        onClick={handleClickOpen}
        variant="contained"
        className="btn"
        startIcon={<EditIcon />}
      >
        Write your review
      </Button>

      <Dialog
        fullScreen={max_width600 ? true : false}
        open={open}
        onClose={handleClose}
        TransitionComponent={Transition}
        fullWidth
        maxWidth="sm"
      >
        {max_width600 ? (
          <AppBar sx={{ position: "relative" }}>
            <Toolbar style={{ background: "#000" }}>
              <IconButton
                edge="start"
                color="inherit"
                onClick={handleClose}
                aria-label="close"
              >
                <CloseRoundedIcon />
              </IconButton>
              <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
                Create Review
              </Typography>
              <Button autoFocus color="inherit" onClick={handleCreateReview}>
                Apply
              </Button>
            </Toolbar>
          </AppBar>
        ) : (
          <DialogTitle>Create Review</DialogTitle>
        )}

        <DialogContent>
          <TextField
            sx={{ mb: 2, mt: 2 }}
            id="name"
            label="User name"
            type="text"
            fullWidth
            variant="outlined"
            value={newReview.username}
            onChange={(e) =>
              setNewReview({ ...newReview, username: e.target.value })
            }
          />
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              flexDirection: "column",
            }}
          >
            Your review about this product:
            <Rating
              name="order-product-rating"
              className="order-product-rating"
              icon={<StarRateRoundedIcon fontSize="inherit" />}
              emptyIcon={<StarOutlineRoundedIcon fontSize="inherit" />}
              value={newReview.rating}
              onChange={(event, newValue) => {
                setNewReview(newValue);
                setNewReview({ ...newReview, rating: newValue });
              }}
            />
            {!newReview.rating && (
              <FormHelperText sx={{ color: "hsl(94, 59%, 35%)" }}>
                require rating *
              </FormHelperText>
            )}
          </Box>

          <TextField
            sx={{ mt: 2 }}
            multiline
            rows={2}
            id="name"
            label="Review"
            type="text"
            fullWidth
            variant="outlined"
            value={newReview.review}
            onChange={(e) =>
              setNewReview({ ...newReview, review: e.target.value })
            }
          />

          <Box sx={{ mt: 2 }}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DemoContainer
                components={[
                  "DatePicker",
                  "DesktopDatePicker",
                  "MobileDatePicker",
                ]}
              >
                <DatePicker
                  label="Starting Request Date"
                  maxDate={dayjs(todayDate)}
                  format="DD/MM/YYYY"
                  name="created_at"
                  value={newReview.created_at}
                  onChange={(value) => {
                    setNewReview({ ...newReview, created_at: value });
                  }}
                />
              </DemoContainer>
            </LocalizationProvider>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button color="warning" onClick={handleClose}>
            Cancel
          </Button>
          <LoadingButton
            loading={ProductRatingStore.isCreateLoading}
            sx={{ color: "#171717" }}
            onClick={handleCreateReview}
            disabled={
              !newReview.rating ||
              newReview.username === "" ||
              newReview.created_at === ""
            }
          >
            Submit
          </LoadingButton>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default CreateReviewModal;
